<template>
    <div class="appContainer" :class="{ 'supportPageWrap' : $route.meta.supportPage }">
        <Header/>

        <Notification v-if="notificationActive" :text="notificationText" />

        <transition-group v-if="$mq=='sm'" name="fadeCustom" tag="div" class="wrapper messagesWrapper">
            <Messages
                v-if="messages.length"
                v-for="(message, index) in messages"
                :key="index + 0"
                v-bind="message"
                :i="index"
            />
        </transition-group>

        <UserInfoUpper/>

        <div class="contentWrap" :class="{oneCol : $route.meta.supportPage}">
            <div v-if="($mq=='lg' && !$route.meta.supportPage) || ($mq=='sm' && $route.meta.homePage)" class="sidebar">
                <AccountBalance v-if="($mq=='sm' && $route.meta.homePage) || $mq=='lg'"/>
<!--                <DiscountCode v-if="$route.meta.homePage && $mq=='lg'"/>-->
                <Documents v-if="$mq=='lg' && ($route.meta.homePage || $route.meta.faqPage) && user.documents" />
                <FAQList v-if="locale == 'en' && ($route.meta.homePage || $route.meta.statementsPage ||
                        $route.meta.settingsPage || $route.meta.faqPage)"/>
            </div>

            <router-view/>
        </div>

		<Footer />

        <Navigation
            v-if="$mq=='sm' && ($route.meta.homePage || $route.meta.statementsPage || $route.meta.paymentPage)"/>
    </div>
</template>


<script>
    import {mapState, mapActions} from 'vuex';

    import Header from './Header';
    import Footer from './Footer';
    import Navigation from './Navigation';
    import UserInfoUpper from '../components/UserInfoUpper';

    import AccountBalance from '../components/sidebar/AccountBalance';
    import DiscountCode from '../components/sidebar/DiscountCode';
    import Documents from '../components/sidebar/Documents';
    import Messages from '../components/messages/Message';
    import FAQList from '../components/sidebar/FAQList';
    import Notification from "../components/messages/Notification";

    export default {
        data() {
            return {
                locale: window.lang.getLocale(),
                notificationText: '',
                notificationActive: false,
            }
        },
        components: {
            Notification,
            Header,
            Footer,
            Navigation,
            UserInfoUpper,
            AccountBalance,
            DiscountCode,
            Documents,
            Messages,
            FAQList
        },
        computed: {
            ...mapState(['user', 'messages']),
        },
        methods: {
            ...mapActions(['removeMessages', 'changeLanguage']),
        },
        created() {
            window.addEventListener('beforeunload', this.removeMessages());

            const currentLang = document.getElementsByTagName('html')[0].getAttribute('lang');
            if (currentLang) {

                window.lang.setLocale(currentLang);
                this.changeLanguage(currentLang);
            } else {
                window.lang.setLocale('en');
            }

        },
        watch: {
            $route() {
                if (this.messages.length) {
                    this.removeMessages();
                }
            },
            user: function () {
                if (this.user.activeCardExpireNotification && this.user.activeCardLastNumbers) {
                    this.notificationActive = true;
                    this.notificationText = window.lang.get('components/messages/notification.paymentCardExpires', {numbers: this.user.activeCardLastNumbers});
                }
            },
        }
    }
</script>

